var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"contragents-list",attrs:{"gutter":16,"type":"flex","align":"top"}},_vm._l((_vm.contragents),function(contragent){return _c('i-col',{key:contragent.id,attrs:{"span":"24"}},[_c('contragents-item',{attrs:{"contragent":contragent}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }